export default {
  CLIENT: 1,
  PROFESSIONAL: 2,
  EMPRESA: 3
};
